export default function getStringBetween(str: string, start: string, end:string) {
  const regex = new RegExp(`${start}(.*?)(?:${end}|$)`, 's');
  const result = str.match(regex);
  return result 
         ? (result[1] 
            || result[0] 
            || '').trim() 
         : str.trim();
}